module.exports = __webpack_public_path__ + "static/media/20_strawberry.df75e168.JPG";